export default {
    manage_deleteAssetSubtype_title: "Delete Asset Subtype",
    manage_deleteAssetSubtypes_title: "Delete Asset Subtypes",
    manage_deleteAssetSubtypes_description: "Are you sure you want to delete these Asset Subtypes?",
    manage_deleteAssetSubtype_description: "Are you sure want to delete this Asset Subtype?",
    manage_deleteAssetSubtype_successMessage: "Asset Subtype deleted",
    manage_deleteAssetSubtypes_successMessage: "Asset Subtypes deleted",
    manage_deleteAssetSubtypes_are_in_use: "It is not possible to delete Asset Subtype in use",
    manage_deleteAssetSubtypes_successMessageUpdate: "Asset Subtypes was deleted successfully",
    manage_deleteAssetSubtype_successMessageUpdate: "Asset Subtype was deleted successfully",
}